module.exports = __webpack_public_path__ + "static/media/Icons- firstaid.4ee7d5bf.svg";